import { useEffect, useState, useRef } from "react";
import { supabase } from "@/lib/supabaseClient";

type MessageRow = {
  id: string;
  sender_type: string;
  sender_name: string | null;
  content: string;
  created_at: string;
};

export default function MessageThread({ threadId }: { threadId: string }) {
  const [messages, setMessages] = useState<MessageRow[]>([]);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from("messages")
        .select("id,sender_type,sender_name,content,created_at")
        .eq("thread_id", threadId)
        .order("created_at", { ascending: true });
      setMessages((data ?? []) as MessageRow[]);
    })();
  }, [threadId]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="border rounded-md p-4 h-80 overflow-y-auto space-y-3 bg-background">
      {messages.map((m) => (
        <div key={m.id} className="text-sm">
          <div className="text-muted-foreground">{m.sender_name ?? m.sender_type} — {new Date(m.created_at).toLocaleString()}</div>
          <pre className="whitespace-pre-wrap font-sans">{m.content}</pre>
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}


